import React, { useRef, ReactElement } from 'react';
import { HStack } from '@cad-arc';
import { UnitHistoryLeftPane } from './unit-history-left-pane/unit-history-left-pane';
import { UnitHistoryRightPane } from './unit-history-right-pane/unit-history-right-pane';
import { FrPageBody } from '../../fr-page-layout/fr-page-body';
import { useApplicationType } from '../../common/hooks/use-application-type';

export function UnitHistoryBody(): ReactElement {
    const resultsScrollElementRef = useRef(null);
    const { isFirstResponder } = useApplicationType();

    const commonStyles = {
        gap: '0px',
        flexGrow: 1,
        overflow: 'hidden',
        borderBottomRightRadius: 'inherit',
    };

    const commonContent = (
        <>
            <UnitHistoryLeftPane resultsScrollElementRef={resultsScrollElementRef} />
            <UnitHistoryRightPane resultsScrollElementRef={resultsScrollElementRef} />
        </>
    );

    return isFirstResponder ? (
        <FrPageBody
            customStyles={{
                ...commonStyles,
                display: 'flex',
            }}
        >
            {commonContent}
        </FrPageBody>
    ) : (
        <HStack {...commonStyles}>{commonContent}</HStack>
    );
}
